export const COMMENT_ID_QUERY_PARAM = 'highlightComment';
export const REPLY_ID_QUERY_PARAM = 'highlightReply';
